var chunkToChildrenMap = {
	"65834": [
		81374,
		26374,
		50297,
		245,
		21141,
		73523,
		59054,
		84036,
		55504,
		14934,
		67263,
		82015,
		75938,
		44015,
		78080,
		62513,
		94020,
		73549,
		83934,
		75262,
		34855,
		88315
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };